import { render } from "./InstructorRequestsPanel.vue?vue&type=template&id=5ce5f6ea&scoped=true"
import script from "./InstructorRequestsPanel.vue?vue&type=script&lang=js"
export * from "./InstructorRequestsPanel.vue?vue&type=script&lang=js"

import "./InstructorRequestsPanel.vue?vue&type=style&index=0&id=5ce5f6ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce5f6ea"]])

export default __exports__